import { APP_ROUTES } from 'shared/routes'

export const FULLSCREEN_CHAT_ID_ROUTE_PARAM = 'chat_id' as const

/**
 * True when the pathname is the fullscreen Alvie AI Pro chat route
 * (`/ai/chat` or `/ai/chat/<chat_id>`), not settings or other `/ai` children.
 */
export const isCopilotFullscreenChatPath = (pathname: string): boolean => {
  const chatPage = APP_ROUTES.copilot.chatPage
  return pathname === chatPage || pathname.startsWith(`${chatPage}/`)
}

/**
 * Reads the Next.js optional catch-all `chat_id` param for fullscreen Alvie AI Pro
 * (`ai/chat/[[...chat_id]]`). Absent / empty on `/ai/chat` (new chat); a single
 * segment on `/ai/chat/<id>` arrives as a one-element array.
 */
export const getFullscreenChatIdFromRouteParams = (
  params: Record<string, string | string[] | undefined>
): string | null => {
  const value = params[FULLSCREEN_CHAT_ID_ROUTE_PARAM]
  if (typeof value === 'string' && value !== '') return value
  if (Array.isArray(value) && typeof value[0] === 'string' && value[0] !== '') return value[0]
  return null
}
